export const STUDIO_SETTINGS_SECTIONS = [
  'overview',
  'analytics',
  'profile',
  'pricing',
  'discounts',
  'requests',
  'room',
  'fans',
  'schedule',
  'safety',
  'compliance',
  'payouts',
  'roxy',
] as const;

export type StudioSettingsSection = (typeof STUDIO_SETTINGS_SECTIONS)[number];

export const STUDIO_SETTINGS_LABELS: Record<StudioSettingsSection, string> = {
  overview: 'common.studio.settings.nav.overview',
  analytics: 'common.studio.settings.nav.analytics',
  profile: 'common.studio.settings.nav.profile',
  pricing: 'common.studio.settings.nav.pricing',
  discounts: 'common.studio.settings.nav.discounts',
  requests: 'common.studio.settings.nav.requests',
  room: 'common.studio.settings.nav.room',
  fans: 'common.studio.settings.nav.fans',
  schedule: 'common.studio.settings.nav.schedule',
  safety: 'common.studio.settings.nav.safety',
  compliance: 'common.studio.settings.nav.compliance',
  payouts: 'common.studio.settings.nav.payouts',
  roxy: 'common.studio.settings.nav.roxy',
};

export const STUDIO_SETTINGS_PATHS: Record<StudioSettingsSection, string> = {
  overview: '/settings/overview',
  analytics: '/settings/analytics',
  profile: '/settings/profile',
  pricing: '/settings/pricing',
  discounts: '/settings/discounts',
  requests: '/settings/requests',
  room: '/settings/room',
  fans: '/settings/fans',
  schedule: '/settings/schedule',
  safety: '/settings/safety',
  compliance: '/settings/compliance',
  payouts: '/settings/payouts',
  roxy: '/roxy',
};

export function isStudioSettingsSection(value: string): value is StudioSettingsSection {
  return (STUDIO_SETTINGS_SECTIONS as readonly string[]).includes(value);
}
